import {Avatar, Layout, Menu, Popup} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {useLogout, useUserInfo} from '../../services';
import {t} from '../../localization';
import {useSettingsTask} from '../../scenes/modals/settings/task';

export const ProfileAvatar: React.FC = () => {
  const userInfo = useUserInfo();

  const logout = useLogout();

  const showSettingsDialog = useSettingsTask(
    userInfo?.userid,
    userInfo?.firstname,
    userInfo?.lastname,
  );

  const handleActionSelected = useCallback(
    (index: number) => {
      switch (index) {
        case 0: {
          showSettingsDialog();
          break;
        }
        case 1: {
          logout();
          break;
        }
      }
    },
    [logout, showSettingsDialog],
  );

  return userInfo ? (
    <Layout backgroundColor="background_mono_primary" flex padding="16">
      <Popup
        trigger={
          <Avatar
            name={`${userInfo.firstname} ${userInfo.lastname}`}
            shape="round"
          />
        }>
        {closePopup => (
          <Menu
            items={[
              t('components.profileavatar.settings'),
              t('components.profileavatar.logoutAction'),
            ]}
            onChange={index => {
              handleActionSelected(index);
              closePopup();
            }}
          />
        )}
      </Popup>
    </Layout>
  ) : null;
};
